module.exports = __webpack_public_path__ + "static/media/app-icon-sl.383a8d0d.svg";